import React from 'react';
import '../styles/spinner-loader.css';

interface SpinnerLoaderProps {
    size?: string;
    color?: string;
}

const SpinnerLoader: React.FC<SpinnerLoaderProps> = ({ size = '0.75em', color = 'inherit' }) => {
    return (
        <div
            className="spinner-loader"
            style={{ width: size, height: size, color: color }}
        ></div>
    );
};

export default SpinnerLoader;
